var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarPerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0859 3.20312H1.83594C1.49023 3.20312 1.21094 3.48242 1.21094 3.82812V16.3281C1.21094 16.6738 1.49023 16.9531 1.83594 16.9531H18.0859C18.4316 16.9531 18.7109 16.6738 18.7109 16.3281V3.82812C18.7109 3.48242 18.4316 3.20312 18.0859 3.20312ZM16.2832 7L10.4824 12.8047C1131 12.8338 10.4134 12.8501 10.3721 12.8501C10.3307 12.8501 10.2911 12.8338 10.2617 12.8047L8.02539 10.5684L4.65625 13.9395C4.62688 13.9685 4.58723 13.9848 4.5459 13.9848C4.50457 13.9848 4.46491 13.9685 4.43555 13.9395L3.7168 13.2207C3.68772 13.1913 3.67141 13.1517 3.67141 13.1104C3.67141 13.069 3.68772 13.0294 3.7168 13L7.91406 8.80078C7.97461 8.74023 8.07422 8.74023 8.13477 8.80078L10.3711 11.0352L15.3418 6.0625C15.4023 6.00195 15.502 6.00195 15.5625 6.0625L16.2812 6.78125C16.3438 6.83984 16.3438 6.93945 16.2832 7Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPerformance);
export default __webpack_public_path__ + "static/media/sidebar-performance.03a2675bc45039f253d193de8c9deeb0.svg";
export { ForwardRef as ReactComponent };